export default __webpack_public_path__ + "static/media/res-project-3.93fce9f8.webp";